export default "__VITE_PUBLIC_ASSET__a5053884__"